export var SubscriptionTransactionStatus;
(function (SubscriptionTransactionStatus) {
    SubscriptionTransactionStatus["Pending"] = "Pending";
    SubscriptionTransactionStatus["Completed"] = "Completed";
    SubscriptionTransactionStatus["Failed"] = "Failed";
    SubscriptionTransactionStatus["Cancelled"] = "Cancelled";
    SubscriptionTransactionStatus["Refunded"] = "Refunded";
})(SubscriptionTransactionStatus || (SubscriptionTransactionStatus = {}));
//# sourceMappingURL=subscription-transaction-status.const.js.map